import { render, staticRenderFns } from "./TipoVehiculo.vue?vue&type=template&id=72afbc6e&"
import script from "./TipoVehiculo.vue?vue&type=script&lang=ts&"
export * from "./TipoVehiculo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports